import { classNames } from "../utils/classNames";
import Button from "./Button";
import Card from "./Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

import { FieldValues, UseFormSetError } from "react-hook-form";

interface FormLayoutProps<T extends FieldValues> {
  /*
   * This is the handleSubmit function provided by
   * react hook form
   */
  handleSubmit: Function;
  /*
   * Custom function to handle the formdata after
   * validation from yup resolver
   */
  handleFormSubmit: Function;
  /*
   * Generally passed so that the error from server
   * can be mapped to coresponding form input
   */
  setError: UseFormSetError<T>;
  /*
   * Text to display on the button
   */
  buttonLabel: string;
  /*
   * State provided to change the submit button
   */
  isLoading: boolean;
  /*
   * To disable the form button
   */
  disabled: boolean;
  children: React.ReactNode;
}

const Form = <T extends FieldValues>({
  handleSubmit,
  handleFormSubmit,
  setError,
  buttonLabel,
  isLoading,
  children,
  disabled = false,
}: FormLayoutProps<T>) => {
  return (
    <>
      <Card>
        <>
          <form
            onSubmit={handleSubmit((data: any) =>
              handleFormSubmit(data, setError)
            )}
            autoComplete="off"
          >
            {children}

            <div className={tw`flex justify-end w-full items-center`}>
              <div className={tw`w-32 mr-4`}>
                <Button
                  label={buttonLabel}
                  isLoading={isLoading}
                  disabled={disabled}
                />
              </div>
            </div>
          </form>
        </>
      </Card>
    </>
  );
};

export default Form;
